module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-2@2x-21c687cf104aae7159484e66c6bdc321.png";